import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key.tsx';

export const createSessionSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    type: z.string().nonempty(t('session.validation.sessionTypeRequired')),
    title: z.string().min(2, t('session.validation.titleMinLength')),
    plannedDurationMinutes: z.string().regex(/^(\d{2}):(\d{2})$/, t('session.validation.plannedDurationFormat')),
    isInLibrary: z.boolean().optional(),
  });
};
